import { render } from "./zhuanbing.vue?vue&type=template&id=6987b2f8&scoped=true"
import script from "./zhuanbing.vue?vue&type=script&lang=js"
export * from "./zhuanbing.vue?vue&type=script&lang=js"

import "./zhuanbing.vue?vue&type=style&index=0&id=6987b2f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6987b2f8"]])

export default __exports__